(() => {
  const bindPromoHover = () => {
      const promoHoverMql = window.matchMedia('(hover: hover) and (pointer: fine)');
      const blocks = document.querySelectorAll('.custom-promo-block--has-hover');

      if (!promoHoverMql.matches) {
        blocks.forEach((block) => {
          block.classList.remove('custom-promo-block--show-second');
        });
        return;
      }

      blocks.forEach((block) => {
        if (block.dataset.promoHoverBound === 'true') {
          return;
        }

        const firstBtn = block.querySelector('[data-first-button]');
        const secondBtn = block.querySelector('[data-second-button]');

        if (!firstBtn && !secondBtn) {
          return;
        }

        const showMain = () => {
          block.classList.remove('custom-promo-block--show-second');
          if (firstBtn) firstBtn.classList.add('active');
          if (secondBtn) secondBtn.classList.remove('active');
        };
        
        const showSecond = () => {
          block.classList.add('custom-promo-block--show-second');
          if (secondBtn) secondBtn.classList.add('active');
          if (firstBtn) firstBtn.classList.remove('active');
        };

        if (firstBtn) {
          firstBtn.addEventListener('pointerenter', showMain);
        }

        if (secondBtn) {
          secondBtn.addEventListener('pointerenter', showSecond);
        }

        block.dataset.promoHoverBound = 'true';
      });
  };
  const linkHover = () =>{
    const navLinks = document.querySelectorAll('.header__primary-nav > ul > li > .header_link:not([aria-controls])');

    navLinks.forEach((link) => {
      const li = link.closest('li');
      if (!li) return;

      link.addEventListener('pointerenter', () => {
        const linkWidth = link.offsetWidth;
        li.style.setProperty('--underline-width', `${linkWidth}px`);
      });

      link.addEventListener('pointerleave', () => {
        li.style.setProperty('--underline-width', '0px');
      });
    });
  }
  const initHomeHeaderOverlay = () => {
    if (window.smilodoxHomeHeaderOverlay) return;
    window.smilodoxHomeHeaderOverlay = true;

    const threshold = 16;
    const blockingSelector = '#search-drawer[open], #cart-drawer[open], dialog[open]';
    const overlayClasses = ['is-home-overlay-ready', 'is-home-at-top', 'is-overlay-blocked'];

    const sync = () => {
      const header = document.querySelector('x-header.header--home-overlay');
      if (!header) return;

      const hero = document.querySelector('#main > .shopify-section:first-child [data-home-hero]');
      if (!hero) {
        header.classList.remove(...overlayClasses);
        return;
      }

      header.classList.add('is-home-overlay-ready');
      header.classList.toggle('is-home-at-top', window.scrollY <= threshold);
      header.classList.toggle('is-overlay-blocked', Boolean(document.querySelector(blockingSelector)));
    };

    sync();
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('pageshow', (event) => {
      sync();
      if (event.persisted) requestAnimationFrame(sync);
    });
    document.addEventListener('shopify:section:load', sync);
    document.addEventListener('shopify:section:unload', sync);
    document.addEventListener('shopify:section:reorder', sync);

    const main = document.querySelector('#main');
    if (main) {
      new MutationObserver(sync).observe(main, { childList: true });
      new MutationObserver(sync).observe(main, {
        subtree: true,
        attributes: true,
        attributeFilter: ['data-home-hero']
      });
    }

    new MutationObserver(sync).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['open'],
      subtree: true
    });
  };

  const onReady = () => {
    linkHover()
    bindPromoHover();
    initHomeHeaderOverlay();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }
})();
